import { RentalPeriodContainer } from '../../containers/advancedFilters/RentalPeriodContainer';
import { IFilter } from '../../types/advancedFilters';

export const rentalPeriod: IFilter = {
  component: RentalPeriodContainer,
};
